<template>
  <b-row class="match-height">
    <b-col lg="12">
      <b-card title="Receive Purchase Order By Purchasing">
        <!-- Modal Reference-->
        <b-modal
          id="modal-return"
          v-model="modalReturnShow"
          centered
          hide-footer
          title="Return Item"
        >
          <b-form-group>
            <input
              v-model="purchaseOrderDetailId"
              type="hidden"
              name="purchaseOrderDetailId"
              class="form-control"
            >
            <label for="email">Item QTY :</label>
            <input
              v-model="returnItemQty"
              type="number"
              name="returnItemQty"
              class="form-control"
              :min="0"
            >
          </b-form-group>
          <b-form-group>
            <input
              type="button"
              class="btn btn-primary pull-right"
              value="Save"
              @click="saveReturnItem()"
            >
          </b-form-group>
        </b-modal>
        <b-form
@keyup.enter.prevent=""
@submit.prevent="submitReceivePurchaseOrder"
>
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Surat Jalan *"
                label-for="suratJalan"
                label-cols-md="12"
              >
                <b-form-input
                  id="suratJalan"
                  v-model="suratJalan"
                  placeholder="No Surat Jalan"
                  required="required"
                />
              </b-form-group>
              <b-form-group
label="Notes"
label-for="notes"
label-cols-md="12"
>
                <b-form-input
id="notes"
v-model="notes"
placeholder="Notes"
/>
              </b-form-group>
              <b-form-group
                label="Image *"
                label-for="image"
                label-cols-md="12"
              >
                <b-form-file
                  id="file"
                  ref="uploadFile"
                  placeholder="Choose one or more files or drop it here..."
                  drop-placeholder="Drop files here..."
                  type="file"
                  @change="handleFilesUpload"
                />
              </b-form-group>
              <b-row>
                <b-col
cols="3"
class="text-center font-weight-bold"
>
                  Item name
                </b-col>
                <b-col
cols="3"
class="text-center font-weight-bold"
>
                  Item Unit
                </b-col>
                <b-col
cols="2"
class="text-center font-weight-bold"
>
                  QTY Ordered
                </b-col>
                <b-col
cols="2"
class="text-center font-weight-bold"
>
                  QTY Received
                </b-col>
                <b-col
cols="2"
class="text-center font-weight-bold"
>
                  Actions
                </b-col>
              </b-row>
              <p />
              <b-row
v-for="chosen in chosens"
:key="chosen.value"
>
                <br>
                <b-col cols="3 text-center">
                  <b-list-group>
                    <b-list-group-item href="#">
                      {{ chosen.label }}
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
                <b-col cols="3 text-center">
                  <b-form-input
                    v-model="chosen.unit"
                    readonly
                  />
                </b-col>
                <b-col cols="2 text-center">
                  <b-form-input
                    v-model="chosen.qty"
                    :max="chosen.qty"
                    readonly
                  />
                </b-col>
                <b-col cols="2 text-center">
                  <b-form-input
                    v-model="chosen.receive"
                    type="number"
                    :max="chosen.received"
                    required="required"
                  />
                </b-col>
                <b-col cols="2 text-center">
                  <b-button
                    size="sm"
                    type="button"
                    variant="primary"
                    class="mr-1"
                    @click="returnItem(chosen.value)"
                  >
                    <feather-icon
icon="BoxIcon"
size="18"
/>
                    Retur
                  </b-button>
                </b-col>
                <b-col cols="12">
                  <br>
                </b-col>
              </b-row>
              <div
class="alert alert-info"
role="alert"
>
                Max file upload is 20MB
              </div>
            </b-col>
            <!-- submit and reset -->
            <b-col offset-md="12">
              <b-button
type="submit"
variant="primary"
class="mr-1"
                :disabled="submitButtonDisabled"
>
                Submit
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BListGroup,
  BListGroupItem,
  BFormDatepicker,
  BFormFile,
} from "bootstrap-vue"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import axios from "axios"
import moment from "moment-timezone"
import Ripple from "vue-ripple-directive"
import { ref } from "@vue/composition-api"
import apiEndpoints from '@/constants/apiEndpoints'

const VersionCheck = ""
const file = ""
const items = []
const chosenPR = ref()
const chosens = []
const shipmentTo = ""
const itemId = ""
const purchaseOrderProject = ""
const purchaseOrderCostCenter = ""
const purchaseOrderQtyRequested = 0
const purchaseOrderStatus = ""
const purchaseOrderNotes = ""
const deliverySchedule = ""
const modalReferenceShow = false
const itemReference = ""
const itemLink = ""
const itemPrice = ""
const itemDescription = ""
const contacts = []
const branches = []
const references = []
const currencies = []
const chosenBranch = ""
const chosenContact = ""
const termOfPayment = ""
const billingAddress = ""
const deliveryAddress = ""
const purchaseOrderDetailId = ""
const modalReturnShow = false
const itemCurrency = ""
const returnItemQty = ""
const modalReferenceHistoryShow = false
const submitButtonDisabled = false

export default {
  components: {
    BFormFile,
    BFormDatepicker,
    BListGroup,
    BListGroupItem,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      submitButtonDisabled,
      returnItemQty,
      purchaseOrderDetailId,
      modalReturnShow,
      itemCurrency,
      currencies,
      deliveryAddress,
      chosenBranch,
      branches,
      termOfPayment,
      billingAddress,
      modalReferenceHistoryShow,
      chosenContact,
      contacts,
      itemId,
      deliverySchedule,
      file,
      modalReferenceShow,
      itemReference,
      itemLink,
      itemPrice,
      itemDescription,
      references,
      VersionCheck,
      items,
      chosenPR,
      chosens,
      shipmentTo,
      purchaseOrderProject,
      purchaseOrderCostCenter,
      purchaseOrderQtyRequested,
      purchaseOrderStatus,
      purchaseOrderNotes,
    }
  },
  created() {
    window.setInterval(() => {
      this.removeReadOnly()
    }, 1000)
  },
  mounted() {
    this.getDetails()
  },
  methods: {
    removeReadOnly() {
      const searches = document.getElementsByClassName("vs__search")
      for (let i = 0; i < searches.length; i += 1) {
        searches[i].removeAttribute("readonly")
      }
    },
    getDetails() {
      const userToken = this.$cookies.get("userToken")
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      }
      const item = JSON.parse(localStorage.getItem("poDetail"))
      const id = item.purchase_order_id
      const obj1 = {
        title: "Created",
        content: `Purchase Order Has been Created at ${this.dateSimple(
          item.purchase_order_created_time,
        )}`,
        stepCssClass: "has-step-green",
        boxCssClass: "has-color-red",
      }
      const obj2 = {
        title: "Lab Manager",
        content:
          item.purchase_order_is_accepted_by_supervisor === true
            ? `Purchase Order Has been Accepted by Lab Manager at ${this.dateSimple(
                item.purchase_order_created_time,
              )}`
            : `Purchase Order Has not been Accepted By Lab Manager`,
        stepCssClass:
          item.purchase_order_is_accepted_by_supervisor === true
            ? "has-step-green"
            : "has-step-red",
      }
      const obj3 = {
        title: "Received",
        content:
          item.purchase_order_is_received === true
            ? `Purchase Order Has been Received at ${this.dateSimple(
                item.purchase_order_created_time,
              )}`
            : `Purchase Order Has not been Received`,
        stepCssClass:
          item.purchase_order_is_received === true
            ? "has-step-green"
            : "has-step-red",
      }
      this.statusItems = []
      this.statusItems.push(obj1)
      this.statusItems.push(obj2)
      this.statusItems.push(obj3)
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_PURCHASE_ORDER_DETAILS}${id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            const temp = []
            response.data.data.map(elem => {
              temp.push({
                itemId: elem.item.item_id,
                label: `${elem.item.item_name} (${elem.item.item_code})`,
                unit: elem.item.unit ? elem.item.unit.unit_name : '-',
                value: elem.purchase_order_detail_id,
                qty: elem.purchase_order_detail_item_qty,
                receive: elem.purchase_order_detail_item_qty - elem.purchase_order_detail_item_received,
                received: elem.purchase_order_detail_item_qty - elem.purchase_order_detail_item_received,
                return: 0,
              })
            })
            this.chosens = temp
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Fetching Data success",
                icon: "CheckIcon",
                variant: "success",
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Fetching Data failed",
                icon: "CheckIcon",
                variant: "danger",
              },
            })
          }
        })
    },
    submitReceivePurchaseOrder() {
      this.submitButtonDisabled = true
      const userToken = this.$cookies.get("userToken")
      const item = JSON.parse(localStorage.getItem("poDetail"))
      const id = item.purchase_order_id
      let totalReceived = 0
      const header = {
        "Content-Type": "multipart/form-dataitem",
        Authorization: `Bearer ${userToken}`,
      }
      const formData = new FormData()
      if (typeof this.file[0] !== "undefined") {
        this.chosens.map(o => {
          totalReceived += parseInt(o.receive)
        })
        formData.append("file", this.file[0], this.file[0].name)
        formData.append("purchase_order_no_surat_jalan", this.suratJalan)
        formData.append(
          "purchase_order_receiving_note",
          this.purchaseOrderNotes,
        )
        formData.append(
          "purchase_order_purchasing_receive_total_received",
          totalReceived,
        )
        formData.append("purchase_order_items", JSON.stringify(this.chosens))
        formData.append("time", moment())
        const url = `${process.env.VUE_APP_API_URL}${apiEndpoints.API_RECEIVE_PURCHASING_PURCHASE_ORDER}${id}`
        axios
          .post(url, formData, { headers: header })
          .then(response => {
            if (response.data.success === true) {
              this.submitButtonDisabled = false
              this.chosens = []
              this.chosenContact = ""
              this.shipmentBy = ""
              this.deliveryAddress = ""
              this.deliverySchedule = ""
              this.termOfPayment = ""
              this.chosenBranch = null
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Purchase Order Receive Success",
                  icon: "CheckIcon",
                  variant: "success",
                },
              })
              this.$router.replace({
                name: "apps-purchase-order-pre-receive-purchasing",
              })
            } else {
              this.submitButtonDisabled = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Purchase Order Receive Failed",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              })
            }
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Purchase Order Receive Failed",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          })
      } else {
      this.submitButtonDisabled = false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please Upload The Image",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        })
      }
    },
    getOptionLabel(option) {
      return (option && option.label) || ""
    },
    inputSearch(search) {

    },
    handleFilesUpload(e) {
      this.file = e.target.files || e.dataTransfer.files
    },
    dateSimple(value, format = "MM/DD/YYYY") {
      return moment.utc(value).tz('Asia/Jakarta').format(format)
    },
    returnItem(id) {
      this.purchaseOrderDetailId = id
      this.chosens.map(o => {
        if (o.value === id) {
          this.returnItemQty = o.return
        }
      })
      this.modalReturnShow = true
    },
    saveReturnItem() {
  let invalid = false

  this.chosens.forEach(o => {
    if (o.value === this.purchaseOrderDetailId) {
      const received = parseInt(o.received)
      const ret = parseInt(this.returnItemQty)

      // ✅ VALIDATION
      if (Number.isNaN(ret) || ret < 0 || ret > received) {
        invalid = true
      } else {
        o.return = ret
      }
    }
  })

  if (!invalid) {
    this.modalReturnShow = false
    this.purchaseOrderDetailId = ''
    this.returnItemQty = ''

    this.$toast({
      component: ToastificationContent,
      props: {
        title: 'Return Item Saved',
        icon: 'CheckIcon',
        variant: 'success',
      },
    })
  } else {
    this.$toast({
      component: ToastificationContent,
      props: {
        title: 'Invalid return quantity',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    })
  }
},
    choose(referenceId, itemIdRef) {
      const index = this.chosens.findIndex(x => x.value === itemIdRef)
      this.chosens[index].reference_id = referenceId
      this.modalReferenceHistoryShow = false
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Price Chosen",
          icon: "CheckIcon",
          variant: "success",
        },
      })
    },
  },
}
</script>
